export const months = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const toDateParts = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
    if (isoMatch) {
      const [, year, month, day] = isoMatch;
      return {
        day: Number(day),
        month: Number(month),
        year: Number(year),
      };
    }
  }
  const candidate = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(candidate.getTime())) {
    return null;
  }
  return {
    day: candidate.getUTCDate(),
    month: candidate.getUTCMonth() + 1,
    year: candidate.getUTCFullYear(),
  };
};

export const dateToString = (date = null) => {
  const parts = toDateParts(date || new Date());
  if (!parts) return "";
  const day = String(parts.day).padStart(2, "0");
  const month = String(parts.month).padStart(2, "0");
  return `${day}/${month}/${parts.year}`;
};

export const timeToString = (date = null) => {
  let tempDate = new Date();
  if (date) tempDate = new Date(date);

  let hours = tempDate.getHours();
  if (hours < 10) hours = `0${hours}`;
  let minutes = tempDate.getMinutes();
  if (minutes < 10) minutes = `0${minutes}`;

  return `${hours}:${minutes}`;
};

export const getPeriodToString = (date = null) => {
  let tempDate = new Date();
  if (date) tempDate = new Date(date);

  const year = tempDate.getFullYear();
  const month = months[tempDate.getMonth()];

  return `${month} ${year}`;
};

export const convertStringToDate = (str = "1/1/2021") => {
  const tempStr = str.split("/");
  const tempDate = new Date();
  tempDate.setDate(Number(tempStr[0]));
  tempDate.setMonth(Number(tempStr[1]) - 1);
  tempDate.setFullYear(Number(tempStr[2]));
  return new Date(tempDate).getTime();
};
